export default "__VITE_ASSET__Cz0mFa69__"